module.exports = __webpack_public_path__ + "static/img/3.54d7eb7b.jpg";